module.exports = __webpack_public_path__ + "static/how-it-works-icon-1-b3735743b44184acdc0832cbaa083caf.svg";